import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import * as _ from "lodash";
import * as _moment from "moment";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GunningsService } from "src/app/services/gunnings/gunnings.service";
import { TundishService } from "src/app/services/tundish/tundish.service";
import { MatTableDataSource } from "@angular/material/table";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { FormGroup, FormControl } from "@angular/forms";
import { IncidentsService } from "src/app/services/incidents/incidents.service";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-root",
  templateUrl: "./tundish-modal.component.html",
  styleUrls: ["./tundish-modal.component.scss"],
})
export class TundishModalComponent implements OnInit {
  addCampaignForm: FormGroup = new FormGroup({});
  editCampaignForm: FormGroup = new FormGroup({});
  addConsumptionForm: FormGroup = new FormGroup({});
  editConsumptionForm: FormGroup = new FormGroup({});
  editOperationForm: FormGroup = new FormGroup({});
  editIntervalForm: FormGroup = new FormGroup({});

  displayedColumnsAlarmsByCampaign: string[];
  dataSourceAlarmsByCampaign: MatTableDataSource<any> = new MatTableDataSource(
    []
  );
  @ViewChild("campaignAlarmsPaginator") campaignAlarmsPaginator: MatPaginator;

  displayedColumnsAlarmsByOperation: string[];
  dataSourceAlarmsByOperation: MatTableDataSource<any> = new MatTableDataSource(
    []
  );
  @ViewChild("operationAlarmsPaginator") operationAlarmsPaginator: MatPaginator;

  displayedColumnsIntervalsByOperation: string[] = [
    "id",
    "inicio",
    "fin",
    "duracion",
    "arena",
    "silicato",
    "catalizador",
    "tundish",
    "acciones",
  ];
  dataSourceIntervalsByOperation: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationIntervalsPaginator")
  operationIntervalsPaginator: MatPaginator;

  displayedColumnsIntervalsReportSandByOperation: string[] = [
    "id",
    "inicio",
    "fin",
    "cantidad",
  ];
  dataSourceIntervalsReportSandByOperation: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationIntervalsReportSandPaginator")
  operationIntervalsReportSandPaginator: MatPaginator;

  displayedColumnsIntervalsReportCatalystByOperation: string[] = [
    "id",
    "inicio",
    "fin",
    "cantidad",
  ];
  dataSourceIntervalsReportCatalystByOperation: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationIntervalsReportCatalystPaginator")
  operationIntervalsReportCatalystPaginator: MatPaginator;

  displayedColumnsIntervalsReportSilicateByOperation: string[] = [
    "id",
    "inicio",
    "fin",
    "cantidad",
  ];
  dataSourceIntervalsReportSilicateByOperation: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationIntervalsReportSilicatePaginator")
  operationIntervalsReportSilicatePaginator: MatPaginator;

  displayedColumnsOperationsByCampaign: string[] = [
    "id",
    "inicio",
    "fin",
    "duracion",
    "arena",
    "silicato",
    "catalizador",
  ];
  dataSourceOperationsByCampaign: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationsCampaignPaginator")
  operationsCampaignPaginator: MatPaginator;

  displayedColumnsIntervalsByCampaign: string[] = [
    "id",
    "inicio",
    "fin",
    "duracion",
    "arena",
    "silicato",
    "catalizador",
  ];
  dataSourceIntervalsByCampaign: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("intervalsCampaignPaginator")
  intervalsCampaignPaginator: MatPaginator;

  wait: boolean = false;
  isPrintEnabled: boolean = false;

  operations_chart_data = {
    data: [],
    layout: {},
  };

  intervals_chart_data = {
    data: [],
    layout: {},
  };

  // PDF variables
  counter: number = 0;
  length: number = 0;
  pdf: jsPDF;
  headerPDFContent: any;
  headerContentHeight: number = 0;
  report_header = "report_header";
  report_divs_operation = [
    "report_graph_sand",
    "report_graph_catalyst",
    "report_graph_silicate",
    "report_alarms",
  ];
  report_divs_campaign = [
    "report_graph_operations_chart",
    "report_graph_intervals_chart",
    "report_kpis",
    "report_alarms_chart",
  ];

  // Collection MongoDB
  collectionCampaigns = "campaigns";
  collectionConsumptions = "consumptions";
  collectionNameIntervals = "9a72b49a-82ff-4406-89c8-b8e21d5ddc11";
  collectionNameSubintervals = "f05ec735-1752-4926-9cda-aa546fa2add7";

  // Valocity Indictators
  catalystEngineVelocity: string = "0";
  sandEngineVelocity: string = "0";
  silicateEngineVelocity: string = "0";

  // KPIs
  steelProductionQuantity: number = 0;
  consumedSandQuantity: number = 0;
  consumedSilicateQuantity: number = 0;
  consumedCatalystQuantity: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private gunningsService: GunningsService,
    private tundishService: TundishService,
    private incidentsService: IncidentsService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.doGenerateFormControls();

    if (this.data.option == -1 && this.data.id == -1 && this.data.type == 0) {
      // Añadir Campaña
      this.addCampaignForm.controls.campaignName.setValue(this.data.name);
      this.addCampaignForm.controls.tundishUuid.setValue(this.data.disp);
    } else if (this.data.option == 0 && this.data.type == 0) {
      // Editar Campaña
      this.editCampaignForm.controls.campaignName.setValue(
        this.data.metadata.name
      );
      this.editCampaignForm.controls.campaignUuid.setValue(
        this.data.metadata.uuid
      );
      this.editCampaignForm.controls.tundishUuid.setValue(
        this.data.metadata.disp
      );
      this.editCampaignForm.controls.campaignStartDate.setValue(
        _moment(this.data.metadata.start * 1000)
      );
      this.editCampaignForm.controls.campaignEndDate.setValue(
        _moment(this.data.metadata.end * 1000)
      );
    } else if (
      this.data.option == -1 &&
      this.data.id == -1 &&
      this.data.type == 2
    ) {
      // Añadir Producción Acero
      this.addConsumptionForm.controls.tundishUuid.setValue(this.data.disp);
    } else if (this.data.option == 0 && this.data.type == 2) {
      // Editar Producción Acero
      this.editConsumptionForm.controls.steelConsumption.setValue(
        this.data.metadata.consumption
      );
      this.editConsumptionForm.controls.steelCastings.setValue(
        this.data.metadata.castings
      );
      this.editConsumptionForm.controls.tundishUuid.setValue(
        this.data.metadata.disp
      );
      this.editConsumptionForm.controls.consumptionTimestamp.setValue(
        _moment(this.data.metadata.timestamp * 1000)
      );
    } else if (this.data.option == 8 && this.data.type == 1) {
      // Editar Operacion
      this.editOperationForm.controls.operationSandConsumption.setValue(
        this.data.metadata.arena
      );
      this.editOperationForm.controls.operationCatalystConsumption.setValue(
        this.data.metadata.catalizador
      );
      this.editOperationForm.controls.operationSilicateConsumption.setValue(
        this.data.metadata.silicato
      );
      this.editOperationForm.controls.operationStartDate.setValue(
        _moment(this.data.metadata.start * 1000)
      );
      this.editOperationForm.controls.operationEndDate.setValue(
        _moment(this.data.metadata.end * 1000)
      );
      this.editOperationForm.controls.operationTundishUuid.setValue(
        this.data.metadata.disp
      );
      this.editOperationForm.controls.operationTundishNumber.setValue(
        this.data.metadata.num
      );
      this.editOperationForm.controls.operationUuid.setValue(
        this.data.metadata.uuid
      );
    } else if (this.data.option == 9 && this.data.type == 1) {
      // Editar Subintervalo
      this.editIntervalForm.controls.intervalSandConsumption.setValue(
        this.data.metadata.arena
      );
      this.editIntervalForm.controls.intervalCatalystConsumption.setValue(
        this.data.metadata.catalizador
      );
      this.editIntervalForm.controls.intervalSilicateConsumption.setValue(
        this.data.metadata.silicato
      );
      this.editIntervalForm.controls.intervalStartDate.setValue(
        _moment(this.data.metadata.start * 1000)
      );
      this.editIntervalForm.controls.intervalEndDate.setValue(
        _moment(this.data.metadata.end * 1000)
      );
      this.editIntervalForm.controls.intervalTundishUuid.setValue(
        this.data.metadata.disp
      );
      this.editIntervalForm.controls.intervalTundishNumber.setValue(
        this.data.metadata.num
      );
      this.editIntervalForm.controls.intervalUuid.setValue(
        this.data.metadata.uuid
      );
    } else if (this.data.option == 2 && this.data.type == 1) {
      // Arena (Producto -> 1)
      this.doBuildOperationReportSandSection(
        this.data.id,
        this.data.disp,
        this.data.coldmag,
        this.data.inicio,
        this.data.fin,
        1
      );
    } else if (this.data.option == 3 && this.data.type == 1) {
      // Silicato (Producto -> 2)
      this.doBuildOperationReportSilicateSection(
        this.data.id,
        this.data.disp,
        this.data.coldmag,
        this.data.inicio,
        this.data.fin,
        2
      );
    } else if (this.data.option == 5 && this.data.type == 1) {
      // Informe de Producción (Operación)
      this.doBuildOperationReport(
        this.data.td,
        this.data.id,
        this.data.disp,
        this.data.coldmag
      );
    } else if (this.data.option == 3 && this.data.type == 0) {
      // Informe de Producción (Campaña)
      this.doBuildCampaignReport(
        this.data.td,
        this.data.id,
        this.data.disp,
        this.data.coldmag
      );
    } else if (this.data.option == 4 && this.data.type == 0) {
      // Visualizar KPIs
      this.doBuildCampaignReportKPISection(
        this.data.disp,
        this.data.coldmag,
        this.data.inicio,
        this.data.fin
      );
    } else if (this.data.option == 6 && this.data.type == 1) {
      // Catalizador (Producto -> 3)
      this.doBuildOperationReportCatalystSection(
        this.data.id,
        this.data.disp,
        this.data.coldmag,
        this.data.inicio,
        this.data.fin,
        3
      );
    } else if (this.data.option == 7 && this.data.type == 1) {
      // Intervalos de Trabajo (Operación)
      this.doBuildIntervalsTableData(
        this.data.disp,
        this.data.td,
        this.data.inicio,
        this.data.fin,
        this.data.disps
      );
    }
  }

  ngAfterViewInit() {
    if (this.data.option == 2 && this.data.type == 0) {
      if (this.data.alarms.length > 0) {
        this.displayedColumnsAlarmsByCampaign = ["alarma", "timestamp"];
        this.dataSourceAlarmsByCampaign = new MatTableDataSource(
          this.data.alarms
        );
        this.campaignAlarmsPaginator.pageSize = 5;
        this.campaignAlarmsPaginator.pageIndex = 0;
        this.campaignAlarmsPaginator.length = this.data.alarms.length;
        this.dataSourceAlarmsByCampaign.paginator =
          this.campaignAlarmsPaginator;
      }
    } else if (this.data.option == 4 && this.data.type == 1) {
      if (this.data.alarms.length > 0) {
        this.displayedColumnsAlarmsByOperation = ["alarma", "timestamp"];
        this.dataSourceAlarmsByOperation.data = this.data.alarms;
        this.operationAlarmsPaginator.pageSize = 5;
        this.operationAlarmsPaginator.pageIndex = 0;
        this.operationAlarmsPaginator.length = this.data.alarms.length;
        this.dataSourceAlarmsByOperation.paginator =
          this.operationAlarmsPaginator;
      }
    }
  }

  doGenerateFormControls() {
    this.addCampaignForm.addControl(
      "tundishUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.addCampaignForm.addControl(
      "campaignName",
      new FormControl({ value: "", disabled: true })
    );
    this.addCampaignForm.addControl("campaignStartDate", new FormControl(""));
    this.addCampaignForm.addControl("campaignEndDate", new FormControl(""));
    this.editCampaignForm.addControl(
      "tundishUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editCampaignForm.addControl(
      "campaignUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editCampaignForm.addControl("campaignName", new FormControl(""));
    this.editCampaignForm.addControl("campaignStartDate", new FormControl(""));
    this.editCampaignForm.addControl("campaignEndDate", new FormControl(""));
    this.addConsumptionForm.addControl(
      "tundishUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.addConsumptionForm.addControl("steelConsumption", new FormControl(""));
    this.addConsumptionForm.addControl("steelCastings", new FormControl(""));
    this.addConsumptionForm.addControl(
      "consumptionTimestamp",
      new FormControl("")
    );
    this.editConsumptionForm.addControl(
      "tundishUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editConsumptionForm.addControl(
      "steelConsumption",
      new FormControl("")
    );
    this.editConsumptionForm.addControl("steelCastings", new FormControl(""));
    this.editConsumptionForm.addControl(
      "consumptionTimestamp",
      new FormControl("")
    );
    this.editOperationForm.addControl(
      "operationTundishUuid",
      new FormControl("")
    );
    this.editOperationForm.addControl(
      "operationTundishNumber",
      new FormControl({ value: "", disabled: true })
    );
    this.editOperationForm.addControl(
      "operationUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editOperationForm.addControl(
      "operationSandConsumption",
      new FormControl({ value: "", disabled: true })
    );
    this.editOperationForm.addControl(
      "operationCatalystConsumption",
      new FormControl({ value: "", disabled: true })
    );
    this.editOperationForm.addControl(
      "operationSilicateConsumption",
      new FormControl({ value: "", disabled: true })
    );
    this.editOperationForm.addControl(
      "operationStartDate",
      new FormControl({ value: "", disabled: true })
    );
    this.editOperationForm.addControl(
      "operationEndDate",
      new FormControl({ value: "", disabled: true })
    );
    this.editIntervalForm.addControl(
      "intervalTundishUuid",
      new FormControl("")
    );
    this.editIntervalForm.addControl(
      "intervalTundishNumber",
      new FormControl({ value: "", disabled: true })
    );
    this.editIntervalForm.addControl(
      "intervalUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editIntervalForm.addControl(
      "intervalSandConsumption",
      new FormControl({ value: "", disabled: true })
    );
    this.editIntervalForm.addControl(
      "intervalCatalystConsumption",
      new FormControl({ value: "", disabled: true })
    );
    this.editIntervalForm.addControl(
      "intervalSilicateConsumption",
      new FormControl({ value: "", disabled: true })
    );
    this.editIntervalForm.addControl(
      "intervalStartDate",
      new FormControl({ value: "", disabled: true })
    );
    this.editIntervalForm.addControl(
      "intervalEndDate",
      new FormControl({ value: "", disabled: true })
    );
  }

  doBuildCampaignReport(td, uuid, disp, coldmag) {
    this.tundishService
      .getCampaignById(this.collectionCampaigns, uuid)
      .subscribe(
        (data) => {
          console.log(data);
          let campaign = data.data.findCampaignById;
          this.doBuildCampaignReportOperationsSection(
            disp,
            coldmag,
            campaign.inicio,
            campaign.fin
          );
          this.doBuildCampaignReportIntervalsSection(
            disp,
            coldmag,
            campaign.inicio,
            campaign.fin
          );
          this.doBuildCampaignReportKPISection(
            disp,
            coldmag,
            campaign.inicio,
            campaign.fin
          );
          this.doBuildCampaignReportAlarmsSection(
            campaign.inicio,
            campaign.fin
          );
          setTimeout(() => {
            console.log("Building report for Campaign UUID -> ", campaign.uuid);
            console.log("Alarms -> ", this.data.report.alarms);
            this.doBuildCampaignReportHeaderSection(
              campaign,
              this.data.report.alarms
            );
            this.isPrintEnabled = true;
          }, 10000);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildOperationReport(td, uuid, disp, coldmag) {
    this.tundishService.getOperationById(td, uuid).subscribe(
      (data) => {
        let operation = data.data.findIntervalById;
        this.doBuildOperationReportSandSection(
          this.data.id,
          this.data.disp,
          coldmag,
          operation.inicio,
          operation.fin,
          1
        );
        this.doBuildOperationReportCatalystSection(
          this.data.id,
          this.data.disp,
          coldmag,
          operation.inicio,
          operation.fin,
          2
        );
        this.doBuildOperationReportSilicateSection(
          this.data.id,
          this.data.disp,
          coldmag,
          operation.inicio,
          operation.fin,
          3
        );
        this.doBuildOperationReportAlarmsSection(
          this.data.id,
          this.data.disp,
          coldmag,
          operation.inicio,
          operation.fin
        );
        setTimeout(() => {
          console.log("Building report for Operation UUID -> ", operation.uuid);
          console.log("Alarms -> ", this.data.report.alarms);
          this.doBuildReportData(operation, this.data.report.alarms);
          this.isPrintEnabled = true;
        }, 10000);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doBuildCampaignReportHeaderSection(campaign, data) {
    this.tundishService
      .getOperationsByTundishBetweenDates(
        this.collectionNameIntervals,
        campaign.disp,
        campaign.inicio,
        campaign.fin
      )
      .subscribe(
        (data) => {
          let operations = data.data.findIntervalsBetweenDates;
          this.data.report.operations = operations.length;
          this.tundishService
            .getOperationsByTundishBetweenDates(
              this.collectionNameSubintervals,
              campaign.disp,
              campaign.inicio,
              campaign.fin
            )
            .subscribe(
              (data) => {
                let intervals = data.data.findIntervalsBetweenDates;
                this.data.report.uuid = campaign._id;
                this.data.report.id = campaign.nombre;
                this.data.report.start = campaign.inicio;
                this.data.report.end = campaign.fin;
                this.data.report.duration = campaign.fin - campaign.inicio;
                this.data.report.intervals = intervals.length;
                this.data.report.alarms = this.data.report.alarms;
                this.doPlotAlarmsSummaryChart(this.data.report.alarms);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildCampaignReportOperationsSection(disp, coldmag, inicio, fin) {
    let chart_traces = [];
    let chart_layout = {
      yaxis: {
        showgrid: true,
        zeroline: false,
        showline: false,
        showticklabels: false,
      },
    };
    let sandTraceValues = []; // Sand data
    let silicateTraceValues = []; // Silicate data
    let catalystTraceValues = []; // Catalyst data
    let operationTraceValues = [];

    this.tundishService
      .getOperationsByTundishBetweenDates(
        this.collectionNameIntervals,
        disp,
        inicio,
        fin
      )
      .subscribe(
        (data) => {
          console.log(data);
          let operations = data.data.findIntervalsBetweenDates;
          let paginator = this.operationsCampaignPaginator;
          this.dataSourceOperationsByCampaign.data = operations;
          paginator.pageSize = 10;
          paginator.pageIndex = 0;
          paginator.length = operations.length;
          this.dataSourceOperationsByCampaign.paginator = paginator;
          // Build Data for Gantt Chart
          for (let i = 0; i < operations.length; i++) {
            let operation = operations[i];
            if (
              operation.campos.arena.kilos !== undefined &&
              operation.campos.arena.kilos != null
            )
              sandTraceValues.push(
                this.doRoundNumber(operation.campos.arena.kilos)
              );
            else sandTraceValues.push(0);
            if (
              operation.campos.silicato.litros !== undefined &&
              operation.campos.silicato.litros != null
            )
              silicateTraceValues.push(
                this.doRoundNumber(operation.campos.silicato.litros)
              );
            else silicateTraceValues.push(0);
            if (
              operation.campos.catalizador.litros !== undefined &&
              operation.campos.catalizador.litros != null
            )
              catalystTraceValues.push(
                this.doRoundNumber(operation.campos.catalizador.litros)
              );
            else catalystTraceValues.push(0);
            operationTraceValues.push(i + 1);
          }
          let sandTrace = {
            x: operationTraceValues,
            y: sandTraceValues,
            type: "bar",
            name: "Arena (Kgs)",
            text: sandTraceValues.map(String),
            textposition: "auto",
            //hoverinfo: 'none',
            opacity: 0.5,
            /*
                    marker: 
                    {
                        color: 'rgb(158,202,225)',
                        line: 
                        {
                            color: 'rgb(8,48,107)',
                            width: 1.5
                        }
                    }
                    */
          };

          let silicateTrace = {
            x: operationTraceValues,
            y: silicateTraceValues,
            type: "bar",
            name: "Silicato (Lts)",
            text: silicateTraceValues.map(String),
            textposition: "auto",
            //hoverinfo: 'none',
            /*
                    marker: 
                    {
                        color: 'rgba(58,200,225,.5)',
                        line: 
                        {
                            color: 'rgb(8,48,107)',
                            width: 1.5
                        }
                    }
                    */
          };
          let catalystTrace = {
            x: operationTraceValues,
            y: catalystTraceValues,
            type: "bar",
            name: "Catalizador (Lts)",
            text: catalystTraceValues.map(String),
            textposition: "auto",
            //hoverinfo: 'none',
            /*
                    marker: 
                    {
                        color: 'rgba(58,200,225,.5)',
                        line: 
                        {
                            color: 'rgb(8,48,107)',
                            width: 1.5
                        }
                    }
                    */
          };

          // Add traces to array of traces
          chart_traces.push(sandTrace);
          chart_traces.push(silicateTrace);
          chart_traces.push(catalystTrace);
          // Log
          console.log("Chart Traces -> ", chart_traces);
          console.log("Chart Layout -> ", chart_layout);
          // Make assignation to global variable of HTML component
          this.data.operations_chart_data.data = chart_traces;
          this.data.operations_chart_data.layout = chart_layout;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildCampaignReportIntervalsSection(disp, coldmag, inicio, fin) {
    let chart_traces = [];
    let chart_layout = {
      yaxis: {
        showgrid: true,
        zeroline: false,
        showline: false,
        showticklabels: false,
      },
    };
    let sandTraceValues = []; // Sand data
    let silicateTraceValues = []; // Silicate data
    let catalystTraceValues = []; // Catalyst data
    let operationTraceValues = [];

    this.tundishService
      .getOperationsByTundishBetweenDates(
        this.collectionNameSubintervals,
        disp,
        inicio,
        fin
      )
      .subscribe(
        (data) => {
          console.log(data);
          let intervals = data.data.findIntervalsBetweenDates;
          let paginator = this.intervalsCampaignPaginator;
          this.dataSourceIntervalsByCampaign.data = intervals;
          paginator.pageSize = 10;
          paginator.pageIndex = 0;
          paginator.length = intervals.length;
          this.dataSourceIntervalsByCampaign.paginator = paginator;
          // Build Data for Gantt Chart
          for (let i = 0; i < intervals.length; i++) {
            let interval = intervals[i];
            if (
              interval.campos.arena.kilos !== undefined &&
              interval.campos.arena.kilos != null
            )
              sandTraceValues.push(
                this.doRoundNumber(interval.campos.arena.kilos)
              );
            else sandTraceValues.push(0);
            if (
              interval.campos.silicato.litros !== undefined &&
              interval.campos.silicato.litros != null
            )
              silicateTraceValues.push(
                this.doRoundNumber(interval.campos.silicato.litros)
              );
            else silicateTraceValues.push(0);
            if (
              interval.campos.catalizador.litros !== undefined &&
              interval.campos.catalizador.litros != null
            )
              catalystTraceValues.push(
                this.doRoundNumber(interval.campos.catalizador.litros)
              );
            else catalystTraceValues.push(0);
            operationTraceValues.push(i + 1);
          }
          let sandTrace = {
            x: operationTraceValues,
            y: sandTraceValues,
            type: "bar",
            name: "Arena (Kgs)",
            text: sandTraceValues.map(String),
            textposition: "auto",
            //hoverinfo: 'none',
            opacity: 0.5,
            /*
                    marker: 
                    {
                        color: 'rgb(158,202,225)',
                        line: 
                        {
                            color: 'rgb(8,48,107)',
                            width: 1.5
                        }
                    }
                    */
          };

          let silicateTrace = {
            x: operationTraceValues,
            y: silicateTraceValues,
            type: "bar",
            name: "Silicato (Lts)",
            text: silicateTraceValues.map(String),
            textposition: "auto",
            //hoverinfo: 'none',
            /*
                    marker: 
                    {
                        color: 'rgba(58,200,225,.5)',
                        line: 
                        {
                            color: 'rgb(8,48,107)',
                            width: 1.5
                        }
                    }
                    */
          };
          let catalystTrace = {
            x: operationTraceValues,
            y: catalystTraceValues,
            type: "bar",
            name: "Catalizador (Lts)",
            text: catalystTraceValues.map(String),
            textposition: "auto",
            //hoverinfo: 'none',
            /*
                    marker: 
                    {
                        color: 'rgba(58,200,225,.5)',
                        line: 
                        {
                            color: 'rgb(8,48,107)',
                            width: 1.5
                        }
                    }
                    */
          };

          // Add traces to array of traces
          chart_traces.push(sandTrace);
          chart_traces.push(silicateTrace);
          chart_traces.push(catalystTrace);
          // Log
          console.log("Chart Traces -> ", chart_traces);
          console.log("Chart Layout -> ", chart_layout);
          // Make assignation to global variable of HTML component
          this.data.intervals_chart_data.data = chart_traces;
          this.data.intervals_chart_data.layout = chart_layout;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildCampaignReportKPISection(disp, coldmag, inicio, fin) {
    // Obtener el indicador de total de acero producido
    this.tundishService
      .getConsumptionsByTundishBetweenDates(
        this.collectionConsumptions,
        disp,
        inicio,
        fin
      )
      .subscribe(
        (data) => {
          console.log(data);
          let consumptions = data.data.findConsumptionsByDispBetweenDates;
          let producedSteelTotal = 0;
          for (let i = 0; i < consumptions.length; i++) {
            let consumption = consumptions[i];
            producedSteelTotal = producedSteelTotal + consumption.consumo;
          }
          this.steelProductionQuantity = producedSteelTotal;

          // Obtener el indicador todal de consumo de arena (de las operaciones de la campaña)
          this.tundishService
            .getOperationsByTundishBetweenDates(
              this.collectionNameIntervals,
              disp,
              inicio,
              fin
            )
            .subscribe(
              (data) => {
                console.log(data);
                let operations = data.data.findIntervalsBetweenDates;
                let consumedSandTotal = 0;
                let consumedCatalystTotal = 0;
                let consumedSilicateTotal = 0;
                for (let i = 0; i < operations.length; i++) {
                  let operation = operations[i];
                  consumedSandTotal =
                    consumedSandTotal + operation.campos.arena.kilos;
                  consumedSilicateTotal =
                    consumedSilicateTotal + operation.campos.silicato.litros;
                  consumedCatalystTotal =
                    consumedCatalystTotal + operation.campos.catalizador.litros;
                }
                this.consumedSandQuantity = consumedSandTotal;
                this.consumedSilicateQuantity = consumedSilicateTotal;
                this.consumedCatalystQuantity = consumedCatalystTotal;
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildCampaignReportAlarmsSection(inicio, fin) {
    this.incidentsService.getTiposIncidente().subscribe(
      (data) => {
        console.log("getTiposIncidente -> ", data);
        let results = data.data.findTipoDatoEstados;
        let occurrences = [];
        for (let i = 0; i < results.length; i++) {
          let disp = results[i];
          if (disp.nombre == "ColdMag") {
            for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
              if (disp.tipoDatoEstado[j].nombre.includes("FALLO")) {
                let incidente = disp.tipoDatoEstado[j];
                this.incidentsService
                  .getIncidentOccurrencesBetweenDates(
                    disp.uuid,
                    incidente.uuid,
                    inicio * 1000,
                    fin * 1000
                  )
                  .subscribe(
                    (data) => {
                      console.log("findTimeSerie DISP ->", disp.uuid);
                      console.log("findTimeSerie TD ->", incidente.nombre);
                      console.log("findTimeSerie INICIO ->", inicio * 1000);
                      console.log("findTimeSerie FIN ->", fin * 1000);
                      console.log("findTimeSerie ->", data);
                      let timeserie = data.data.findTimeSerie;
                      for (let i = 0; i < timeserie.length; i++) {
                        timeserie[i].uuid = incidente.uuid;
                        timeserie[i].alarma = incidente.nombre;
                        if (timeserie[i].valor == 1) {
                          occurrences.push(timeserie[i]);
                        }
                      }
                      console.log(
                        "Total Alarms Ocurrences OCCURRENCES -> ",
                        occurrences
                      );
                    },
                    (err) => {
                      console.log(err);
                    }
                  );
              }
            }
          }
        }
        this.data.report.alarms = occurrences;
        console.log("Alarms -> ", this.data.report.alarms);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doBuildReportData(operation, data) {
    this.data.report.uuid = operation._id;
    this.data.report.start = operation.inicio;
    this.data.report.end = operation.fin;
    this.data.report.duration = operation.fin - operation.inicio;
    this.data.report.sand = operation.campos.arena.kilos;
    this.data.report.silicate = operation.campos.silicato.litros;
    this.data.report.catalyst = operation.campos.catalizador.litros;
    this.data.report.alarms = data;
    this.doPlotAlarmsSummaryChart(this.data.report.alarms);
  }

  doPlotAlarmsSummaryChart(data) {
    // Initialize arrays
    let pie_x1 = [];
    let pie_y1 = [];
    let pie_data = {
      data: [],
      layout: {},
    };

    for (let i = 0; i < data.length; i++) {
      pie_x1.push(1);
      pie_y1.push(data[i].alarma);
    }
    pie_data.data.push({
      values: pie_x1,
      labels: pie_y1,
      hoverinfo: "label+percent",
      hole: 0.4,
      type: "pie",
    });
    pie_data.layout = { title: "Summary", autosize: true };
    this.data.pie_data = pie_data;
  }

  doBuildOperationReportSandSection(uuid, tund, coldmag, from, to, product) {
    console.log("Retrieving sand consumption for Operation No. -> " + uuid);
    this.tundishService.getDataTypes().subscribe(
      (data) => {
        for (let i = 0; i < data.data.findTipoDatos.length; i++) {
          if (data.data.findTipoDatos[i].nombre == "ARENA") {
            this.doBuildProductDataTimeseries(
              coldmag,
              data.data.findTipoDatos[i].uuid,
              from * 1000,
              to * 1000,
              product
            );
            this.doBuildIntervalsReportSandTableData(
              tund,
              this.collectionNameSubintervals,
              from,
              to
            );
            this.doBuildSandEngineVelocityData(uuid);
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doBuildOperationReportCatalystSection(
    uuid,
    tund,
    coldmag,
    from,
    to,
    product
  ) {
    console.log("Retrieving catalyst consumption for Operation No. -> " + uuid);
    this.tundishService.getDataTypes().subscribe(
      (data) => {
        for (let i = 0; i < data.data.findTipoDatos.length; i++) {
          if (data.data.findTipoDatos[i].nombre == "CATALIZADOR") {
            this.doBuildProductDataTimeseries(
              coldmag,
              data.data.findTipoDatos[i].uuid,
              from * 1000,
              to * 1000,
              product
            );
            this.doBuildIntervalsReportCatalystTableData(
              tund,
              this.collectionNameSubintervals,
              from,
              to
            );
            this.doBuildCatalystEngineVelocityData(uuid);
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doBuildOperationReportSilicateSection(
    uuid,
    tund,
    coldmag,
    from,
    to,
    product
  ) {
    console.log("Retrieving silicate consumption for Operation No. -> " + uuid);
    this.tundishService.getDataTypes().subscribe(
      (data) => {
        for (let i = 0; i < data.data.findTipoDatos.length; i++) {
          if (data.data.findTipoDatos[i].nombre == "SILICATO") {
            this.doBuildProductDataTimeseries(
              coldmag,
              data.data.findTipoDatos[i].uuid,
              from * 1000,
              to * 1000,
              product
            );
            this.doBuildIntervalsReportSilicateTableData(
              tund,
              this.collectionNameSubintervals,
              from,
              to
            );
            this.doBuildSilicateEngineVelocityData(uuid);
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doBuildOperationReportAlarmsSection(uuid, tund, coldmag, from, to) {
    this.tundishService
      .getOperationById(this.collectionNameIntervals, uuid)
      .subscribe(
        (data) => {
          console.log("getOperationById -> ", data);
          let operation = data.data.findIntervalById;
          let operationInicio = operation.inicio;
          let operationFin = operation.fin;
          this.incidentsService.getTiposIncidente().subscribe(
            (data) => {
              console.log("getTiposIncidente -> ", data);
              let results = data.data.findTipoDatoEstados;
              let occurrences = [];
              for (let i = 0; i < results.length; i++) {
                let disp = results[i];
                if (disp.nombre == "ColdMag") {
                  for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
                    if (disp.tipoDatoEstado[j].nombre.includes("FALLO")) {
                      let incidente = disp.tipoDatoEstado[j];
                      this.incidentsService
                        .getIncidentOccurrencesBetweenDates(
                          disp.uuid,
                          incidente.uuid,
                          operationInicio * 1000,
                          operationFin * 1000
                        )
                        .subscribe(
                          (data) => {
                            console.log("findTimeSerie DISP ->", disp.uuid);
                            console.log(
                              "findTimeSerie TD ->",
                              incidente.nombre
                            );
                            console.log(
                              "findTimeSerie INICIO ->",
                              operation.inicio * 1000
                            );
                            console.log(
                              "findTimeSerie FIN ->",
                              operation.fin * 1000
                            );
                            console.log("findTimeSerie ->", data);
                            let timeserie = data.data.findTimeSerie;
                            for (let i = 0; i < timeserie.length; i++) {
                              timeserie[i].uuid = incidente.uuid;
                              timeserie[i].alarma = incidente.nombre;
                              if (timeserie[i].valor == 1) {
                                occurrences.push(timeserie[i]);
                              }
                            }
                            console.log(
                              "Total Alarms Ocurrences OCCURRENCES -> ",
                              occurrences
                            );
                          },
                          (err) => {
                            console.log(err);
                          }
                        );
                    }
                  }
                }
              }
              this.data.report.alarms = occurrences;
              console.log("Alarms -> ", this.data.report.alarms);
            },
            (err) => {
              console.log(err);
            }
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildIntervalsTableData(disp, td, from, to, disps) {
    console.log("Dispositivo -> " + disp);
    console.log("Tipo de Dato -> " + td);
    console.log("From -> " + from);
    console.log("To -> " + to);
    console.log("Disps -> " + disps);
    // No le pasamos el disp para coger todos los subintervalos de trabajo entre fechas. De esta forma, se cogeran todos los intervalos de trabajo existentes entre las fechas de la operación
    this.tundishService
      .getOperationsByTundishBetweenDates(td, null, from, to)
      .subscribe(
        (data) => {
          console.log(data);
          let subintervals = data.data.findIntervalsBetweenDates;
          let paginator = this.operationIntervalsPaginator;
          this.dataSourceIntervalsByOperation.data = subintervals;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = subintervals.length;
          this.dataSourceIntervalsByOperation.paginator = paginator;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildIntervalsReportSandTableData(disp, td, from, to) {
    console.log("Dispositivo -> " + disp);
    console.log("Tipo de Dato -> " + td);
    console.log("From -> " + from);
    console.log("To -> " + to);
    this.tundishService
      .getOperationsByTundishBetweenDates(td, disp, from, to)
      .subscribe(
        (data) => {
          console.log(data);
          let subintervals = data.data.findIntervalsBetweenDates;
          let paginator = this.operationIntervalsReportSandPaginator;
          this.dataSourceIntervalsReportSandByOperation.data = subintervals;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = subintervals.length;
          this.dataSourceIntervalsReportSandByOperation.paginator = paginator;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildIntervalsReportCatalystTableData(disp, td, from, to) {
    console.log("Dispositivo -> " + disp);
    console.log("Tipo de Dato -> " + td);
    console.log("From -> " + from);
    console.log("To -> " + to);
    this.tundishService
      .getOperationsByTundishBetweenDates(td, disp, from, to)
      .subscribe(
        (data) => {
          console.log(data);
          let subintervals = data.data.findIntervalsBetweenDates;
          let paginator = this.operationIntervalsReportCatalystPaginator;
          this.dataSourceIntervalsReportCatalystByOperation.data = subintervals;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = subintervals.length;
          this.dataSourceIntervalsReportCatalystByOperation.paginator =
            paginator;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildIntervalsReportSilicateTableData(disp, td, from, to) {
    console.log("Dispositivo -> " + disp);
    console.log("Tipo de Dato -> " + td);
    console.log("From -> " + from);
    console.log("To -> " + to);
    this.tundishService
      .getOperationsByTundishBetweenDates(td, disp, from, to)
      .subscribe(
        (data) => {
          console.log(data);
          let subintervals = data.data.findIntervalsBetweenDates;
          let paginator = this.operationIntervalsReportSilicatePaginator;
          this.dataSourceIntervalsReportSilicateByOperation.data = subintervals;
          paginator.pageSize = 5;
          paginator.pageIndex = 0;
          paginator.length = subintervals.length;
          this.dataSourceIntervalsReportSilicateByOperation.paginator =
            paginator;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildProductDataTimeseries(disp, td, from, to, product) {
    console.log("Dispositivo -> " + disp);
    console.log("Tipo de Dato -> " + td);
    console.log("From -> " + from);
    console.log("To -> " + to);
    this.tundishService.getTimeseriesData(disp, td, from, to).subscribe(
      (data) => {
        console.log("doBuildProductDataTimeseries -> ", data);
        // Initialize arrays
        let product_graph_info = {
          data: [],
          layout: {},
        };
        let product_graph_x = [];
        let product_graph_y = [];

        let tsSubstractionIndex2 = 0;
        let tsSubstractionIndex1 = 0;

        // Acortar la serie temporal para que no se tengan en cuenta los valores que son constantes (al final)
        for (let i = data.data.findTimeSerie.length - 1; i >= 0; i--) {
          if (
            data.data.findTimeSerie[i].valor !=
            data.data.findTimeSerie[i - 1].valor
          ) {
            tsSubstractionIndex2 = i;
            break;
          }
        }
        // Acortar la serie temporal para que no se tengan en cuenta los valores que son constantes (al principio)
        for (let i = 0; i < data.data.findTimeSerie.length; i++) {
          if (
            data.data.findTimeSerie[i].valor !=
            data.data.findTimeSerie[i + 1].valor
          ) {
            tsSubstractionIndex1 = i;
            break;
          }
        }
        // Recorrer la serie temporal hasta el indice indicado previamente
        for (
          let j = tsSubstractionIndex1 - 10;
          j < tsSubstractionIndex2 + 10;
          j++
        ) {
          if (data.data.findTimeSerie[j] !== undefined) {
            product_graph_x.push(
              new Date(data.data.findTimeSerie[j].fecha / 1000000)
            );
            product_graph_y.push(data.data.findTimeSerie[j].valor);
          }
        }

        product_graph_info.data.push({
          x: product_graph_x,
          y: product_graph_y,
          type: "scatter",
        });
        //product_graph_info.layout = {title: this.data.title +' ('+this.data.id+')'};
        this.data.product_graph_data = product_graph_info;
        if (product == 1)
          this.data.product_graph_data_sand = product_graph_info;
        else if (product == 2)
          this.data.product_graph_data_silicate = product_graph_info;
        else this.data.product_graph_data_catalyst = product_graph_info;
        console.log(this.data.product_graph_data);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  doBuildCatalystEngineVelocityData(uuid) {
    console.log("Retrieve Catalyst Data for Operation -> ", uuid);
    this.tundishService
      .getOperationById(this.collectionNameIntervals, uuid)
      .subscribe(
        (data) => {
          console.log(data);
          let campaign = data.data.findIntervalById;
          this.catalystEngineVelocity =
            campaign.campos.catalizador.relacion != null
              ? campaign.campos.catalizador.relacion
              : "N/A";
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildSandEngineVelocityData(uuid) {
    console.log("Retrieve Sand Data for Operation -> ", uuid);
    this.tundishService
      .getOperationById(this.collectionNameIntervals, uuid)
      .subscribe(
        (data) => {
          let operation = data.data.findIntervalById;
          this.sandEngineVelocity =
            operation.campos.arena.relacion != null
              ? operation.campos.arena.relacion
              : "N/A";
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildSilicateEngineVelocityData(uuid) {
    console.log("Retrieve Catalyst Data for Operation -> ", uuid);
    this.tundishService
      .getOperationById(this.collectionNameIntervals, uuid)
      .subscribe(
        (data) => {
          let operation = data.data.findIntervalById;
          this.silicateEngineVelocity =
            operation.campos.silicato.relacion != null
              ? operation.campos.silicato.relacion
              : "N/A";
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doAddConsumption() {
    let disp = this.addConsumptionForm.get("tundishUuid").value;
    let fecha = this.addConsumptionForm.get("consumptionTimestamp").value;
    let consumo = parseInt(
      this.addConsumptionForm.get("steelConsumption").value
    );
    let coladas = parseInt(this.addConsumptionForm.get("steelCastings").value);
    this.tundishService
      .insertConsumptionByTundish(
        this.collectionConsumptions,
        disp,
        consumo,
        fecha,
        coladas
      )
      .subscribe(
        (data) => {
          this.tundishService
            .getConsumptionsByTundish(this.collectionConsumptions, disp)
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("addConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doAddCampaign() {
    console.log("Add Campaign (Form) -> ", this.addCampaignForm.getRawValue());
    console.log(
      "Add Campaign (Tundish) -> ",
      this.addCampaignForm.get("tundishUuid").value
    );
    console.log(
      "Add Campaign (Name) -> ",
      this.addCampaignForm.get("campaignName").value
    );
    console.log(
      "Add Campaign (Start) -> ",
      this.addCampaignForm.get("campaignStartDate").value
    );
    console.log(
      "Add Campaign (End) -> ",
      this.addCampaignForm.get("campaignEndDate").value
    );
    this.doCheckCampaignDatesAndInsertCampaign(
      this.collectionCampaigns,
      this.addCampaignForm.get("tundishUuid").value,
      this.addCampaignForm.get("campaignStartDate").value,
      this.addCampaignForm.get("campaignEndDate").value,
      this.addCampaignForm.get("campaignName").value
    );
  }

  doCheckCampaignDatesAndInsertCampaign(
    collection: string,
    disp: any,
    startDate: any,
    endDate: any,
    name: any
  ) {
    this.tundishService.getCampaignsByTundish(collection, disp).subscribe(
      (data) => {
        let message = "";
        let error = false;
        let errorsCount = 0;
        let campaigns = data.data.findCampaignsByDisp;
        let addStartDate = new Date(startDate);
        addStartDate.setHours(6, 0, 0, 0);
        console.log("Start date for the campaign to add -> ", addStartDate);
        console.log(
          "Start date for the campaign to add (s) -> ",
          addStartDate.getTime() / 1000
        );
        let addEndDate = new Date(endDate);
        addEndDate.setHours(5, 59, 59, 0);
        console.log("End date for the campaign to add -> ", addEndDate);
        console.log(
          "End date for the campaign to add (s) -> ",
          addEndDate.getTime() / 1000
        );
        for (let i = 0; i < campaigns.length; i++) {
          let start = campaigns[i].inicio;
          let end = campaigns[i].fin;
          if (addStartDate < addEndDate) {
            /*
                        if(startDate > start && endDate < end)
                        {
                            message = message + "Error -> Conflicto de Fechas con la Campaña "+campaigns[i].nombre;
                            errorsCount++;
                        }
                        else if(startDate > start && endDate > end)
                        {
                            message = message + "Error -> Conflicto de Fechas con la Campaña "+campaigns[i].nombre;
                            errorsCount++;
                        }
                        else if(startDate < start && endDate > start)
                        {
                            message = message + "Error -> Conflicto de Fechas con la Campaña "+campaigns[i].nombre;
                            errorsCount++;
                        }
                        else if(startDate < start && endDate > end)
                        {
                            message = message + "Error -> Conflicto de Fechas con la Campaña "+campaigns[i].nombre;
                            errorsCount++;
                        }
                        else
                        {
                            errorsCount = 0;
                        }
                        */
          }
          //console.log(message);
          //console.log("¿Error? -> ", errorsCount > 0);
        }
        if (errorsCount == 0) {
          // En la fecha final ponemos la hora de 23:59:59 (le quitamos un segundo a lo introducido por el usuario)
          this.doInsertCampaign(
            collection,
            disp,
            addStartDate.getTime(),
            addEndDate.getTime(),
            name
          );
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doInsertCampaign(
    collection: string,
    disp: any,
    inicio: any,
    fin: any,
    nombre: any
  ) {
    console.log(inicio);
    console.log(fin);
    this.tundishService
      .insertCampaignByTundish(collection, disp, inicio, fin, nombre)
      .subscribe(
        (data) => {
          console.log(data);
          this.tundishService.getCampaignsByTundish(collection, disp).subscribe(
            (data) => {
              let campaigns = data.data.findCampaignsByDisp;
              this.dialog.getDialogById("addCampaignDialog").close(campaigns);
            },
            (err) => {
              console.log(err);
            }
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doEditCampaign(disp, id) {
    console.log(
      "Edit Campaign (Form) -> ",
      this.editCampaignForm.getRawValue()
    );
    console.log(
      "Edit Campaign (Tundish) -> ",
      this.editCampaignForm.get("tundishUuid").value
    );
    console.log(
      "Edit Campaign (Name) -> ",
      this.editCampaignForm.get("campaignName").value
    );
    console.log(
      "Edit Campaign (Start) -> ",
      this.editCampaignForm.get("campaignStartDate").value
    );
    console.log(
      "Edit Campaign (End) -> ",
      this.editCampaignForm.get("campaignEndDate").value
    );
    console.log("Do edit campaign with ID -> " + id);
    let inicio = this.editCampaignForm.get("campaignStartDate").value;
    let fin = this.editCampaignForm.get("campaignEndDate").value;
    let nombre = this.editCampaignForm.get("campaignName").value;
    let tund = this.editCampaignForm.get("tundishUuid").value;
    this.tundishService
      .updateCampaignById(
        this.collectionCampaigns,
        tund,
        id,
        inicio,
        fin,
        nombre
      )
      .subscribe(
        (data) => {
          console.log(data);
          this.tundishService
            .getCampaignsByTundish(this.collectionCampaigns, tund)
            .subscribe(
              (data) => {
                console.log(data);
                let campaigns = data.data.findCampaignsByDisp;
                this.dialog
                  .getDialogById("editCampaignDialog")
                  .close(campaigns);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doEditOperation(disp, id) {
    console.log(
      "Edit Operation (Form) -> ",
      this.editOperationForm.getRawValue()
    );
    console.log(
      "Edit Operation (Tundish) -> ",
      this.editOperationForm.get("operationTundishUuid").value
    );
    console.log("Edit Operation (Disp) -> ", disp);
    console.log("Do edit operation with ID -> " + id);
    let tund = this.editOperationForm.get("operationTundishUuid").value;
    let nTund = parseInt(
      this.editOperationForm.get("operationTundishNumber").value
    );
    let inicio = this.editOperationForm.get("operationStartDate").value;
    let inicioDate =
      new Date(
        this.editOperationForm.get("operationStartDate").value
      ).getTime() / 1000;
    let fin = this.editOperationForm.get("operationEndDate").value;
    let finDate =
      new Date(this.editOperationForm.get("operationEndDate").value).getTime() /
      1000;
    let arena = this.editOperationForm.get("operationSandConsumption").value;
    let catalizador = this.editOperationForm.get(
      "operationCatalystConsumption"
    ).value;
    let silicato = this.editOperationForm.get(
      "operationSilicateConsumption"
    ).value;
    // Primero, debemos de coger todos los subintervalos de la operación y cambiarles el tundish y el dato
    // Para el dato, query a Neo con el dispositivo o tundish a actualizar como parametro
    /*
        query FindEstructura($uuid: String) {
            findEstructura(uuid: $uuid) {
                tiene {
                uuid
                es {
                    nombre
                }
                }
            }
        }*/
    this.tundishService.getDatoByDisp(tund).subscribe(
      (data) => {
        console.log("getDatoByDisp -> ", data);
        let datoIntervaloUuid;
        let datoSubIntervaloUuid;
        let datos = data.data.findEstructura.tiene;
        console.log(datos);
        for (let i = 0; i < datos.length; i++) {
          if (datos[i].es.nombre === "INTERVALO")
            datoIntervaloUuid = datos[i].uuid;
          else if (datos[i].es.nombre === "SUB_INTERVALO")
            datoSubIntervaloUuid = datos[i].uuid;
        }
        console.log("datoIntervaloUuid -> ", datoIntervaloUuid);
        console.log("datoSubIntervaloUuid -> ", datoSubIntervaloUuid);
        this.tundishService
          .getOperationsByTundishBetweenDates(
            this.collectionNameSubintervals,
            disp,
            inicioDate,
            finDate
          )
          .subscribe(
            (data) => {
              console.log("getOperationsByTundishBetweenDates -> ", data);
              let intervals = data.data.findIntervalsBetweenDates;
              for (let i = 0; i < intervals.length; i++) {
                let interval = intervals[i];
                this.tundishService
                  .assignDispToOperationById(
                    this.collectionNameSubintervals,
                    tund,
                    nTund,
                    datoSubIntervaloUuid,
                    interval._id,
                    interval.inicio,
                    interval.fin,
                    interval.campos.arena.kilos,
                    interval.campos.catalizador.litros,
                    interval.campos.silicato.litros
                  )
                  .subscribe(
                    (data) => {
                      console.log(data);
                      if (i == intervals.length - 1) {
                        // Actualizamos el padre
                        this.tundishService
                          .updateOperationById(
                            this.collectionNameIntervals,
                            tund,
                            nTund,
                            datoIntervaloUuid,
                            id,
                            inicio,
                            fin,
                            arena,
                            catalizador,
                            silicato
                          )
                          .subscribe(
                            (data) => {
                              console.log(data);
                              this.tundishService
                                .getOperationsByTundish(
                                  this.collectionNameIntervals,
                                  disp
                                )
                                .subscribe(
                                  (data) => {
                                    console.log(data);
                                    let operations = data.data.findIntervals;
                                    this.dialog
                                      .getDialogById("editOperationDialog")
                                      .close(operations);
                                  },
                                  (err) => {
                                    console.log(err);
                                  }
                                );
                            },
                            (err) => {
                              console.log(err);
                            }
                          );
                      }
                    },
                    (err) => {
                      console.log(err);
                    }
                  );
              }
            },
            (err) => {
              console.log(err);
            }
          );
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doEditInterval(disp, id) {
    console.log(
      "Edit Interval (Form) -> ",
      this.editIntervalForm.getRawValue()
    );
    console.log(
      "Edit Interval (Tundish) -> ",
      this.editIntervalForm.get("intervalTundishUuid").value
    );
    console.log("Edit Interval (Disp) -> ", disp);
    console.log("Do edit interval with ID -> " + id);
    let tund = this.editIntervalForm.get("intervalTundishUuid").value;
    let nTund = parseInt(
      this.editIntervalForm.get("intervalTundishNumber").value
    );
    let inicio = this.editIntervalForm.get("intervalStartDate").value;
    let inicioDate =
      new Date(this.editIntervalForm.get("intervalStartDate").value).getTime() /
      1000;
    let fin = this.editIntervalForm.get("intervalEndDate").value;
    let finDate =
      new Date(this.editIntervalForm.get("intervalEndDate").value).getTime() /
      1000;
    let arena = this.editIntervalForm.get("intervalSandConsumption").value;
    let catalizador = this.editIntervalForm.get(
      "intervalCatalystConsumption"
    ).value;
    let silicato = this.editIntervalForm.get(
      "intervalSilicateConsumption"
    ).value;
    // Primero, debemos de coger todos los subintervalos de la operación y cambiarles el tundish y el dato
    // Para el dato, query a Neo con el dispositivo o tundish a actualizar como parametro
    /*
        query FindEstructura($uuid: String) {
            findEstructura(uuid: $uuid) {
                tiene {
                uuid
                es {
                    nombre
                }
                }
            }
        }*/
    this.tundishService.getDatoByDisp(tund).subscribe(
      (data) => {
        console.log("getDatoByDisp -> ", data);
        let datoIntervaloUuid;
        let datoSubIntervaloUuid;
        let datos = data.data.findEstructura.tiene;
        console.log(datos);
        for (let i = 0; i < datos.length; i++) {
          if (datos[i].es.nombre === "INTERVALO")
            datoIntervaloUuid = datos[i].uuid;
          else if (datos[i].es.nombre === "SUB_INTERVALO")
            datoSubIntervaloUuid = datos[i].uuid;
        }
        console.log("datoIntervaloUuid -> ", datoIntervaloUuid);
        console.log("datoSubIntervaloUuid -> ", datoSubIntervaloUuid);
        this.tundishService
          .getOperationById(this.collectionNameSubintervals, id)
          .subscribe(
            (data) => {
              console.log(data);
              let interval = data.data.findIntervalById;
              this.tundishService
                .assignDispToOperationById(
                  this.collectionNameSubintervals,
                  tund,
                  nTund,
                  datoSubIntervaloUuid,
                  interval._id,
                  interval.inicio,
                  interval.fin,
                  interval.campos.arena.kilos,
                  interval.campos.catalizador.litros,
                  interval.campos.silicato.litros
                )
                .subscribe(
                  (data) => {
                    console.log(data);
                    this.tundishService
                      .getOperationsByTundish(
                        this.collectionNameSubintervals,
                        disp
                      )
                      .subscribe(
                        (data) => {
                          console.log(data);
                          let intervals = data.data.findIntervals;
                          this.dialog
                            .getDialogById("editIntervalDialog")
                            .close(intervals);
                        },
                        (err) => {
                          console.log(err);
                        }
                      );
                  },
                  (err) => {
                    console.log(err);
                  }
                );
            },
            (err) => {
              console.log(err);
            }
          );
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doEditConsumption(disp, id) {
    console.log("Do edit conusmption with ID -> " + id);
    let fecha = this.editConsumptionForm.get("consumptionTimestamp").value;
    let consumo = parseInt(
      this.editConsumptionForm.get("steelConsumption").value
    );
    let coladas = parseInt(this.editConsumptionForm.get("steelCastings").value);
    let tund = this.editConsumptionForm.get("tundishUuid").value;
    this.tundishService
      .updateConsumptionById(
        this.collectionConsumptions,
        tund,
        id,
        fecha,
        consumo,
        coladas
      )
      .subscribe(
        (data) => {
          this.tundishService
            .getConsumptionsByTundish(this.collectionConsumptions, tund)
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("editConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRemoveCampaign(disp, id) {
    console.log("Do remove campaign with ID -> " + id);
    this.tundishService
      .deleteCampaignById(this.collectionCampaigns, disp, id)
      .subscribe(
        (data) => {
          console.log(data);
          this.tundishService
            .getCampaignsByTundish(this.collectionCampaigns, disp)
            .subscribe(
              (data) => {
                let campaigns = data.data.findCampaignsByDisp;
                this.dialog
                  .getDialogById("removeCampaignDialog")
                  .close(campaigns);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRemoveConsumption(disp, id) {
    console.log("Do remove consumption with ID -> " + id);
    this.tundishService
      .deleteConsumptionById(this.collectionConsumptions, disp, id)
      .subscribe(
        (data) => {
          this.tundishService
            .getConsumptionsByTundish(this.collectionConsumptions, disp)
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("removeConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doAssignInterval(id, option, type, disps) {
    console.log(disps);
    this.tundishService
      .getOperationById(this.collectionNameSubintervals, id)
      .subscribe(
        (data) => {
          let operation = data.data.findIntervalById;
          let start = operation.inicio;
          let end = operation.fin;
          let uuid = operation._id;
          let disp = operation.disp;
          let dispNumber = this.doGetTundishNumber(disp, disps);
          let arena = operation.campos.arena.kilos;
          let catalizador = operation.campos.catalizador.litros;
          let silicato = operation.campos.silicato.litros;
          this.dialog
            .open(TundishModalComponent, {
              width: "25%",
              id: "editIntervalDialog",
              data: {
                title: "Subintervalo de Tundish: Editar/Reasignar",
                id: id,
                content: "",
                option: option,
                metadata: {
                  start: start,
                  end: end,
                  uuid: uuid,
                  disp: disp,
                  num: dispNumber,
                  arena: this.doRoundNumber(arena),
                  catalizador: this.doRoundNumber(catalizador),
                  silicato: this.doRoundNumber(silicato),
                  disps: disps,
                },
                type: type,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (Array.isArray(result)) {
                console.log("Edit Interval (Operation Result) -> ", result);
                this.dataSourceIntervalsByOperation.data = [];
                setTimeout(() => {
                  this.dataSourceIntervalsByOperation.data = result;
                }, 3000);
              }
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doTransformDate(stringDate) {
    if (stringDate != null && stringDate != "") {
      let d = new Date(stringDate);
      return d.toLocaleString();
    }
  }

  doRoundNumber(number) {
    if (number != null) {
      number = Math.round(number * 100) / 100;
    }
    return number;
  }

  doChangeTundishNumber(disps, event, option) {
    console.log(event);
    for (let i = 0; i < disps.length; i++) {
      if (event.value == disps[i].uuid) {
        console.log(disps[i].nombre);
        if (option == 0)
          this.editOperationForm.controls.operationTundishNumber.setValue(
            disps[i].nombre.substr(
              disps[i].nombre.indexOf(" "),
              disps[i].length
            )
          );
        else
          this.editIntervalForm.controls.intervalTundishNumber.setValue(
            disps[i].nombre.substr(
              disps[i].nombre.indexOf(" "),
              disps[i].length
            )
          );
      }
    }
  }

  doPrintOperationReport() {
    // We need to open dialog with spinner
    this.dialog.open(TundishModalComponent, {
      width: "25%",
      id: "printOperationReportDialog",
      data: {
        title: "Generando Informe de Produción (Operación)...",
        wait: true,
      },
    });
    // Initial configuration for Exporting PDF
    this.pdf = new jsPDF("p", "pt", "a4");
    this.length = this.report_divs_operation.length;
    this.counter = -1;

    // Call
    this.doGeneratePDF(0);
  }

  doPrintCampaignReport() {
    // We need to open dialog with spinner
    this.dialog.open(TundishModalComponent, {
      width: "25%",
      id: "printCampaignReportDialog",
      data: {
        title: "Generando Informe de Producción (Campaña)...",
        wait: true,
      },
    });

    // Initial configuration for Exporting PDF
    this.pdf = new jsPDF("p", "pt", "a4");
    this.length = this.report_divs_campaign.length;
    this.counter = -1;

    // Call
    this.doGeneratePDF(1);
  }

  doGeneratePDF(option) {
    let content;
    console.log("Page -> " + this.counter);
    if (this.counter >= 0) {
      if (option == 0) console.log(this.report_divs_operation[this.counter]);
      else console.log(this.report_divs_campaign[this.counter]);
      /*
            content = document.getElementById(this.report_header);
            content = content.after(document.getElementById(this.report_divs[this.counter]));
            */
      if (option == 0)
        content = document.getElementById(
          this.report_divs_operation[this.counter]
        );
      else
        content = document.getElementById(
          this.report_divs_campaign[this.counter]
        );
    } else {
      console.log(this.report_header);
      content = document.getElementById(this.report_header);
    }
    console.log(content);
    const options = { background: "white", scale: 3 };
    html2canvas(content, options)
      .then((canvas) => {
        // Retrieve content from HTML
        var contentPDFFromHTML = canvas.toDataURL("image/png");

        // Adjust Variables
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;

        // PDF Adjustment
        const bufferX = 15;
        const bufferY = 15;
        const imgProps = (this.pdf as any).getImageProperties(
          contentPDFFromHTML
        );
        const pdfWidth = this.pdf.internal.pageSize.getWidth() - 2 * bufferX;
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        if (this.counter < 0) {
          this.headerPDFContent = contentPDFFromHTML;
          this.headerContentHeight = pdfHeight;
        }

        // Add Content to PDF
        if (this.counter >= 0) {
          console.log("Adding images for page -> " + this.counter);
          console.log("Using HTML Header Content -> " + this.headerPDFContent);
          console.log("Using HTML Body Content -> " + contentPDFFromHTML);
          this.pdf.addImage(
            this.headerPDFContent,
            "PNG",
            bufferX,
            bufferY,
            pdfWidth,
            this.headerContentHeight,
            undefined,
            "FAST"
          );
          this.pdf.addImage(
            contentPDFFromHTML,
            "PNG",
            bufferX,
            bufferY + this.headerContentHeight,
            pdfWidth,
            pdfHeight,
            undefined,
            "FAST"
          );
        } else {
          //this.pdf.addImage(contentPDFFromHTML, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
        }

        // Increase counter
        this.counter++;

        // Control if new page needed, else generate the pdf
        if (this.counter < this.length) {
          if (this.counter > 0) this.pdf.addPage();
          return false;
        } else {
          return true;
        }
      })
      .then((result) => {
        if (result) {
          console.log(
            "Generating PDF with a content of " + this.counter + " pages"
          );
          this.pdf.save(
            option == 0 ? "report_operacion.pdf" : "report_campana.pdf"
          );
          if (option == 0)
            this.dialog.getDialogById("printOperationReportDialog").close();
          else this.dialog.getDialogById("printCampaignReportDialog").close(); // Cerramos ventana modal de aviso de generación de informe
          this.dialog.closeAll(); // Cerramos ventana modal 1
        } else {
          console.log(
            "Calling again doGeneratePDF for Page -> " + (this.counter + 1)
          );
          this.doGeneratePDF(option);
        }
      });
  }

  doGetTundishNumber(disp, disps) {
    let tundishNmber = 0;
    for (let i = 0; i < disps.length; i++) {
      let tundish = disps[i];
      if (disp == tundish.uuid) {
        tundishNmber = tundish.nombre.substr(
          tundish.nombre.indexOf(" "),
          tundish.nombre.length
        );
      }
    }
    return tundishNmber;
  }
}
